import smithy from '../images/logo/SmithydaoIcon.png'
import sapphire from '../images/logo/sapphirestudios.png'
import smolage from '../images/logo/SmolageIcon.png'
import Beramonium from '../images/logo/BeramoniumIcon.jpeg'
import beratone from '../images/logo/Beratoneicon.png'
const dataPartner = [
    {
        Title: 'Smithydao',
        img: smithy,
    },
    {
        Title: 'Sapphire Studios',
        img: sapphire,
    },
    {
        Title: 'SmolAge',
        img: smolage,
    },
    {
        Title: 'Beramonium',
        img: Beramonium,
    },
    {
        Title: 'Beratone',
        img: beratone,
    },
]

export default dataPartner;